import { render, staticRenderFns } from "./BoCustomerSerieDatatable.vue?vue&type=template&id=75c1c83f&scoped=true"
import script from "./BoCustomerSerieDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerSerieDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerSerieDatatable.vue?vue&type=style&index=0&id=75c1c83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1c83f",
  null
  
)

export default component.exports